import { render } from "./icon-search.vue?vue&type=template&id=450d169a"
const script = {}

import exportComponent from "/Users/bradwalker/Sites/clark-atlanta-university/web/modules/custom/idfive_calendar_client/calendar_vue_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__